export const SAVE_FOLDER = 'SAVE_FOLDER';
export const SAVE_PROJECT = 'SAVE_PROJECT';
export const SET_FIRST_TIME = 'SET_FIRST_TIME';
